import { render, staticRenderFns } from "./ContentBlockScratchCard.vue?vue&type=template&id=dc25f72a&"
import script from "./ContentBlockScratchCard.vue?vue&type=script&lang=js&"
export * from "./ContentBlockScratchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports